import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';

export function useGetAllowedSignersForFacility(facilityId: number | null | undefined) {
    return useQuery({
        queryKey: [QueryKeys.eicfAllowedSigners, facilityId],
        queryFn: () => EICFTemplatesApi.getAllowedSigners(facilityId as number),
        enabled: !!facilityId && facilityId > 0,
    });
}
